export enum ArtworkTableTheme {
  Horizontal = 'horizontal',
  Vertical = 'vertical',
}
